import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { DxSelectBoxModule } from 'devextreme-angular';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    imports: [NgIf, DxFormModule, DxSelectBoxModule],
    selector: 'app-brake-dialog',
    template: `
        <div class="modal-header">
            <h2 class="modal-title">Brake Options</h2>
        </div>
        <div class="flex-fill d-flex flex-column">
            <div class="card">
                <div class="card-body">
                    <dx-form *ngIf="entity" [formData]="entity" validationGroup="validationGroup">
                        <dxi-item itemType="group">
                            <dxi-item dataField="name">
                                <dxi-validation-rule type="required"> </dxi-validation-rule>
                            </dxi-item>
                            <dxi-item dataField="value">
                                <dxi-validation-rule type="required"> </dxi-validation-rule>
                            </dxi-item>
                            <dxi-item dataField="isTorsionSuspension" [label]="{ text: 'Is Torsion' }" editorType="dxCheckBox"> </dxi-item>
                            <dxi-item dataField="basePrice" editorType="dxNumberBox" [editorOptions]="{ step: 0, min: 0, format: { type: 'currency', precision: 2 } }"> </dxi-item>
                            <dxi-item dataField="price2Axle" editorType="dxNumberBox" [editorOptions]="{ step: 0, min: 0, format: { type: 'currency', precision: 2 } }"> </dxi-item>
                            <dxi-item dataField="price3Axle" editorType="dxNumberBox" [editorOptions]="{ step: 0, min: 0, format: { type: 'currency', precision: 2 } }"> </dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-danger" (click)="save()">Save</button>
            <button class="btn btn-success" (click)="close()">Close</button>
        </div>
    `,
    standalone: true,
})
export class BrakeDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    entity: any;
    entityType: string;
    displayOrder: number;
    validationGroup: 'validationGroup';

    constructor(
        public modalRef: BsModalRef,
        private uow: GenesisUnitOfWork,
        private appInfo: AppInformationService,
    ) {}

    async ngOnInit() {
        await this.getData();

    }

    async getData() {
        if (!this.entity) {
            this.entity = this.uow[this.entityType].createEntity({
                displayOrder: this.displayOrder,
            }) as any;
        }
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true, value: this.entity });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('validationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('validationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
